// Packages

import Vue from 'vue'
import '@/plugins'

// App
import '@/components'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import "core-js/stable";
import "regenerator-runtime/runtime";
//import "@babel/polyfill";
import vuetify from '@/plugins/vuetify';

Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
    created: () => store.dispatch('initStore')
}).$mount('#app')

import 'vuetify/dist/vuetify.min.css'
